import React, { useState, useMemo } from "react";
import { Stack } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";

const PLAN_OPTIONS = ["Founding Driver", "Bronze", "Silver", "Gold", "Platinum"];

const AddPackagePlanDrawer = ({ isOpen, onClose, onAddPlan }) => {
  const [formData, setFormData] = useState({
    name: "",
    deliveries: "",
    expiry_days: 90,
    description: "",
  });


  const isFoundingDriver = useMemo(
    () => formData.name === "Founding Driver",
    [formData.name]
  );

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "name") {
      if (value === "Founding Driver") {
        setFormData((prev) => ({
          ...prev,
          name: value,
          deliveries: "Unlimited",
          expiry_days: 180,
          description: prev.description || "Limited slots. Early adopters only.",
        }));
        return;
      }
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const normalizeDeliveriesForSave = (deliveries) => {
    if (typeof deliveries === "string") {
      const trimmed = deliveries.trim();
      if (trimmed.toLowerCase() === "unlimited") return -1;
      if (trimmed === "") return 0;
      const n = Number(trimmed);
      return Number.isFinite(n) ? n : 0;
    }
    return deliveries;
  };

  const handleSubmit = () => {
    const payload = {
      ...formData,
      deliveries: normalizeDeliveriesForSave(formData.deliveries),
      expiry_days: Number(formData.expiry_days),
    };

    onAddPlan(payload);
    onClose();
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<h2>Add Package Plan</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Select plan"
            type="select"
            options={PLAN_OPTIONS.map((plan) => ({ label: plan, value: plan }))}
          />

          {/* Deliveries: allow typing "Unlimited" or a number */}
          <ReusableInput
            label="Deliveries"
            name="deliveries"
            value={formData.deliveries}
            onChange={handleChange}
            placeholder='Type a number or "Unlimited"'
            type="text"
            isDisabled={isFoundingDriver}
          />

          <ReusableInput
            label="Expiry Days"
            name="expiry_days"
            value={formData.expiry_days}
            onChange={handleChange}
            placeholder="Expiry in days"
            type="number"
            isDisabled={isFoundingDriver}
          />

          <ReusableInput
            label="Description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Plan description"
            type="textarea"
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton onClick={onClose} width="100px" height="40px">
            Cancel
          </GradientButton>
          <GradientButton onClick={handleSubmit} width="100px" height="40px">
            Save
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default AddPackagePlanDrawer;
